export default {
  en: {
    requestAccessMessage:
      'You do not have access to progress further. Would you mind requesting access by clicking the "Request Access" button below?',
    requestAccessMobileMessage:
      "Request access to explore more product features",
    requestAccessButton: "Request Access",
    taxRegimeMessage: "You may have an opportunity to save tax. Check it out !",
    taxRegimeButton: "Compare and Choose",
    dlpAlertMessage:
      "Data loss prevention capabilities are currently supported for Windows in stealth mode with a version greater than 1.3.3. Please talk to the {brandName} sales team to enable this feature for you",
    profileTitle: "Profile",
    logoutButton: "Logout",
    quickMenu: "Quick Menu",
    dashboard: "Dashboard",
    menuSearch: "Menu Search",
    termsOfUse: "Terms of Use",
    privacyPolicy: "Privacy Policy",
    technicalError:
      "It's us! There seems to be some technical difficulties. Please try after some time.",
    requestAccessError:
      "Something went wrong while sending access request for modules. Please try after some time.",
    generalError:
      "Something went wrong. If you continue to see this issue, please contact the platform administrator.",
    requestSentSuccess: "Request sent successfully.",
    restrictedAccessTooltip:
      "Access restricted, please choose the plan and activate your account",
    skipButton: "Skip for now",
    title: "You do not have access to progress further.",
    content:
      "To explore more! Would you mind requesting access by clicking the `Request Access` button below?",
    billing: "Billing",
    benefits: "Benefits",
    members: "Members",
    productivityMonitoring: "Productivity Monitoring",
    camuIntegrationWarning:
      "CAMU Integration is incomplete. Please review the API configuration",
    layoutDataError:
      "Something went wrong while loading the layout data. Please try after some time.",
    activityTrackerNewVersion:
      "A new version of {organizationName} Activity Tracker - is available!",
    upgradeButton: "Upgrade",
    newVersionTitle: "New Version",
    newVersionSubtitle:
      "A new version of application is available in playstore.",
    newVersionQuestion: "Would you like to update it now?",
    dismissButton: "Dismiss",
    updateButton: "Update",
    statisticsError:
      "Something went wrong while loading the statistics. Please try after some time.",
    accessRestricted: "Access to this page is restricted",
    contactHRMessage:
      "Please contact your HR Admin/Manager to get access to this page",
    technicalDifficulties:
      "There seems to be some technical difficulties while fetching data.",
    refreshButton: "Refresh",
    announcementCount: "You have {count} Announcement(s)",
    caughtUpAnnouncements: "You've caught up all announcements",
    newAnnouncementsMessage:
      "We'll let you know when we've got something new for you.",
    invalidEmbedUrl: "Invalid Embed Url",
    notificationCount: "You have {count} Notification(s)",
    caughtUpNotifications: "You've caught up all notifications",
    attendanceRequest:
      "{count} Attendance request(s) waiting for your approval.",
    compensatoryOffRequest:
      "{count} Compensatory off request(s) waiting for your approval.",
    compoffGrantRequest:
      "{count} Compensatory off grant request(s) waiting for your approval.",
    leaveRequest: "{count} Leave request(s) waiting for your approval.",
    resignationRequest:
      "{count} Resignation request(s) waiting for your approval.",
    shortTimeOffRequest:
      "{count} Short time off request(s) waiting for your approval.",
    oneTimeEarningsApproval:
      "{count} One time earnings request(s) waiting for your approval.",
    timesheetRequest: "{count} Timesheet request(s) waiting for your approval.",
    transferRequest: "{count} Transfer request(s) waiting for your approval.",
    travelRequest: "{count} Travel request(s) waiting for your approval.",
    advanceSalaryRequest:
      "{count} Advance salary request(s) waiting for your approval.",
    bonusRequest: "{count} Bonus request(s) waiting for your approval.",
    commissionRequest:
      "{count} Commission request(s) waiting for your approval.",
    deductionRequest: "{count} Deduction request(s) waiting for your approval.",
    financialClosureProcess: "Execute the financial closure process.",
    loanRequest: "{count} Loan request(s) waiting for your approval.",
    deferredLoanRequest:
      "{count} Deferred loan request(s) waiting for your approval.",
    shiftAllowanceRequest:
      "{count} Shift allowance request(s) waiting for your approval.",
    taxDeclarationRequest:
      "{count} Tax declaration request(s) waiting for your approval.",
    taxDeclarationUploadRequest:
      "{count} Tax declaration request(s) waiting for document upload.",
    recruitmentRequest:
      "{count} Recruitment request(s) waiting for your approval.",
    housePropertyRecordRequest:
      "{count} House property record request(s) waiting for your approval.",
    housePropertyUploadRequest:
      "{count} House property upload request(s) waiting for document upload.",
    reimbursementRequest:
      "{count} Reimbursement request(s) waiting for your approval.",
    lopRecoveryApproval:
      "{count} LOP Recovery request(s) waiting for your approval.",
    onDutyPreApprovals:
      "{count} On Duty Pre-approval request(s) waiting for your approval.",
    workFromHomeApproval:
      "{count} Work From Home request(s) waiting for your approval.",
    overTimePreApproval:
      "{count} Over Time Pre-approval request(s) waiting for your approval.",
    workDuringWeekOffApproval:
      "{count} Work During Week Off request(s) waiting for your approval.",
    workDuringHolidayApproval:
      "{count} Work During Holiday request(s) waiting for your approval.",
    jobPostApproval: "{count} Job Post request(s) waiting for your approval.",
    newPositionApproval:
      "{count} New Position request(s) waiting for your approval.",
    recruitmentRequestApproval:
      "{count} Recruitment request(s) waiting for your approval.",
    myprofileApproval:
      "{count} My Profile request(s) waiting for your approval.",
    teamsummaryApproval:
      "{count} Team Summary request(s) waiting for your approval.",
    pulseFlowApproval:
      "{count} Pulse Flow request(s) waiting for your approval.",
    salaryRevisionApproval:
      "{count} Salary Revision request(s) waiting for your approval.",
    languageChanged: "Language changed successfully",

    // Proxy User / Impersonation
    proxyUser: "Proxy User",
    exitProxy: "Exit Proxy",
    selectEmployeeToImpersonate: "Select Employee to Impersonate",
    currentlyViewingAs: "You are currently viewing as",
    impersonatedSession: "(impersonated session)",
    proxyUserConfirmation:
      "You are about to view as {employeeName} - {employeeId}.",
    proxyUserConfirmationTitle:
      "Are you sure you want to proceed with this action?",
    proxyUserConfirmProceed: "Proceed",
    proxyUserConfirmCancel: "Cancel",
  },
  sp: {
    requestAccessMessage:
      'No tiene acceso para continuar. ¿Le importaría solicitar acceso haciendo clic en el botón "Solicitar Acceso" a continuación?',
    requestAccessMobileMessage:
      "Solicitar acceso para explorar más funciones del producto",
    requestAccessButton: "Solicitar Acceso",
    taxRegimeMessage:
      "¡Puede tener la oportunidad de ahorrar impuestos! ¡Compruébalo!",
    taxRegimeButton: "Comparar y Elegir",
    dlpAlertMessage:
      "Las capacidades de prevención de pérdida de datos actualmente son compatibles con Windows en modo sigilo con una versión superior a 1.3.3. Hable con el equipo de ventas de {brandName} para habilitar esta función para usted",
    profileTitle: "Perfil",
    logoutButton: "Cerrar Sesión",
    quickMenu: "Menú Rápido",
    dashboard: "Panel de Control",
    menuSearch: "Búsqueda de Menú",
    termsOfUse: "Términos de Uso",
    privacyPolicy: "Política de Privacidad",
    technicalError:
      "¡Somos nosotros! Parece que hay algunas dificultades técnicas. Por favor, inténtelo después de un tiempo.",
    requestAccessError:
      "Algo salió mal al enviar la solicitud de acceso para los módulos. Por favor, inténtelo después de un tiempo.",
    generalError:
      "Algo salió mal. Si continúa viendo este problema, comuníquese con el administrador de la plataforma.",
    requestSentSuccess: "Solicitud enviada exitosamente.",
    restrictedAccessTooltip:
      "Acceso restringido, por favor elija el plan y active su cuenta",
    skipButton: "Omitir por ahora",
    title: "No tiene acceso para continuar.",
    content:
      "¡Para explorar más! ¿Le importaría solicitar acceso haciendo clic en el botón `Solicitar Acceso` a continuación?",
    billing: "Facturación",
    benefits: "Beneficios",
    members: "Miembros",
    productivityMonitoring: "Monitoreo de Productividad",
    camuIntegrationWarning:
      "La integración de CAMU está incompleta. Por favor, revise la configuración de la API",
    layoutDataError:
      "Algo salió mal al cargar los datos del diseño. Por favor, inténtelo después de un tiempo.",
    activityTrackerNewVersion:
      "¡Hay una nueva versión del Rastreador de Actividad de {organizationName} disponible!",
    upgradeButton: "Actualizar",
    newVersionTitle: "Nueva Versión",
    newVersionSubtitle:
      "Hay una nueva versión de la aplicación disponible en Play Store.",
    newVersionQuestion: "¿Desea actualizarla ahora?",
    dismissButton: "Descartar",
    updateButton: "Actualizar",
    statisticsError:
      "Algo salió mal al cargar las estadísticas. Por favor, inténtelo después de un tiempo.",
    accessRestricted: "El acceso a esta página está restringido",
    contactHRMessage:
      "Por favor, contacte a su Administrador/Gerente de RRHH para obtener acceso a esta página",
    technicalDifficulties:
      "Parece que hay algunas dificultades técnicas al obtener los datos.",
    refreshButton: "Actualizar",
    announcementCount: "Tienes {count} Anuncio(s)",
    caughtUpAnnouncements: "Has visto todos los anuncios",
    newAnnouncementsMessage:
      "Te avisaremos cuando tengamos algo nuevo para ti.",
    invalidEmbedUrl: "URL de incrustación no válida",
    notificationCount: "Tienes {count} Notificación(es)",
    caughtUpNotifications: "Has visto todas las notificaciones",
    attendanceRequest:
      "{count} solicitud(es) de asistencia esperando su aprobación.",
    compensatoryOffRequest:
      "{count} solicitud(es) de día compensatorio esperando su aprobación.",
    compoffGrantRequest:
      "{count} solicitud(es) de otorgamiento de día compensatorio esperando su aprobación.",
    leaveRequest: "{count} solicitud(es) de permiso esperando su aprobación.",
    resignationRequest:
      "{count} solicitud(es) de renuncia esperando su aprobación.",
    shortTimeOffRequest:
      "{count} solicitud(es) de tiempo libre corto esperando su aprobación.",
    oneTimeEarningsApproval:
      "{count} solicitud(es) de ingresos únicos esperando su aprobación.",
    timesheetRequest:
      "{count} solicitud(es) de hoja de tiempo esperando su aprobación.",
    transferRequest:
      "{count} solicitud(es) de transferencia esperando su aprobación.",
    travelRequest: "{count} solicitud(es) de viaje esperando su aprobación.",
    advanceSalaryRequest:
      "{count} solicitud(es) de adelanto de salario esperando su aprobación.",
    bonusRequest: "{count} solicitud(es) de bono esperando su aprobación.",
    commissionRequest:
      "{count} solicitud(es) de comisión esperando su aprobación.",
    deductionRequest:
      "{count} solicitud(es) de deducción esperando su aprobación.",
    financialClosureProcess: "Ejecutar el proceso de cierre financiero.",
    loanRequest: "{count} solicitud(es) de préstamo esperando su aprobación.",
    deferredLoanRequest:
      "{count} solicitud(es) de préstamo diferido esperando su aprobación.",
    shiftAllowanceRequest:
      "{count} solicitud(es) de subsidio por turno esperando su aprobación.",
    taxDeclarationRequest:
      "{count} solicitud(es) de declaración de impuestos esperando su aprobación.",
    taxDeclarationUploadRequest:
      "{count} solicitud(es) de declaración de impuestos esperando carga de documentos.",
    recruitmentRequest:
      "{count} solicitud(es) de reclutamiento esperando su aprobación.",
    housePropertyRecordRequest:
      "{count} solicitud(es) de registro de propiedad esperando su aprobación.",
    housePropertyUploadRequest:
      "{count} solicitud(es) de carga de propiedad esperando carga de documentos.",
    reimbursementRequest:
      "{count} solicitud(es) de reembolso esperando su aprobación.",
    lopRecoveryApproval:
      "{count} solicitud(es) de recuperación de LOP esperando su aprobación.",
    onDutyPreApprovals:
      "{count} solicitud(es) de pre-aprobación de servicio esperando su aprobación.",
    workFromHomeApproval:
      "{count} solicitud(es) de trabajo desde casa esperando su aprobación.",
    overTimePreApproval:
      "{count} solicitud(es) de pre-aprobación de horas extras esperando su aprobación.",
    workDuringWeekOffApproval:
      "{count} solicitud(es) de trabajo durante fin de semana esperando su aprobación.",
    workDuringHolidayApproval:
      "{count} solicitud(es) de trabajo durante día festivo esperando su aprobación.",
    jobPostApproval:
      "{count} solicitud(es) de publicación de empleo esperando su aprobación.",
    newPositionApproval:
      "{count} solicitud(es) de nueva posición esperando su aprobación.",
    recruitmentRequestApproval:
      "{count} solicitud(es) de solicitud de reclutamiento esperando su aprobación.",
    myprofileApproval:
      "{count} solicitud(es) de actualización de perfil esperando su aprobación.",
    teamsummaryApproval:
      "{count} solicitud(es) de actualización de resumen de equipo esperando su aprobación.",
    pulseFlowApproval:
      "{count} solicitud(es) de Pulse Flow esperando su aprobación.",
    salaryRevisionApproval:
      "{count} solicitud(es) de revisión de salario esperando su aprobación.",
    languageChanged: "Idioma cambiado exitosamente",

    // Proxy User / Impersonation
    proxyUser: "Usuario Proxy",
    exitProxy: "Salir del Proxy",
    selectEmployeeToImpersonate: "Seleccionar Empleado para Suplantar",
    currentlyViewingAs: "Actualmente estás viendo como",
    impersonatedSession: "(sesión suplantada)",
    proxyUserConfirmation:
      "Estás a punto de cambiar a la cuenta de {employeeName} - {employeeId}.",
    proxyUserConfirmationTitle:
      "¿Estás seguro de que deseas continuar con esta acción?",
    proxyUserConfirmProceed: "Continuar",
    proxyUserConfirmCancel: "Cancelar",
  },
};
